enum FontSizeEnum {
    Md = 'md',
    Sm = 'sm',
    Xsm = 'xsm',
    Xxsm = 'xxsm',
    Lg = 'lg',
}

export default FontSizeEnum
